var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconButtonMaisInformacoes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 193 c0 -32 2 -35 12 -21 11 16 14 15 39 -9 15 -15 31 -23 35 -20 3 4 -5 20 -20 35 -24 25 -25 28 -9 39 14 10 11 12 -20 12 -37 1 -38 0 -37 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 217 c16 -11 15 -14 -9 -39 -35 -36 -21 -50 15 -15 25 24 28 25 39 9 10 -14 12 -11 12 21 1 36 0 37 -36 36 -32 0 -35 -2 -21 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 75 c-21 -23 -24 -23 -36 -7 -12 15 -13 13 -14 -20 0 -37 1 -38 38 -38 33 1 35 2 20 14 -16 12 -16 15 7 36 14 13 25 27 25 32 0 15 -16 8 -40 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 92 c0 -5 11 -19 25 -32 23 -21 23 -24 7 -36 -15 -12 -13 -13 21 -14 36 0 37 1 37 38 -1 33 -2 35 -14 20 -12 -16 -15 -16 -36 7 -24 25 -40 32 -40 17z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonMaisInformacoes);
export default __webpack_public_path__ + "static/media/iconButtonMaisInformacoes.d596238c.svg";
export { ForwardRef as ReactComponent };